var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"footerBg",class:{'d-none': _vm.$route.fullPath === '/'},attrs:{"fluid":""}},[_c('b-container',[_c('b-row',[_c('b-col',[_c('p',{staticClass:"m-0 white-text"},[_vm._v("\n                        Eviar © "+_vm._s(new Date().getFullYear())+" All rights reserved\n                    ")])])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }